import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, TemplateRef, ViewContainerRef, } from '@angular/core';
import { Setting, } from '@app-state';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil, } from 'rxjs/operators';
var UiContextDirectiveBase = /** @class */ (function () {
    function UiContextDirectiveBase(_ref, _container, _appState) {
        this._ref = _ref;
        this._container = _container;
        this._appState = _appState;
        this._destroyed$ = new Subject();
    }
    UiContextDirectiveBase.prototype.ngOnInit = function () {
        var _this = this;
        this._appState
            .settings
            .get$(Setting.isModernFolderSystemEnabled)
            .pipe(distinctUntilChanged(), takeUntil(this._destroyed$))
            .subscribe(function (value) {
            _this._container.clear();
            if (_this._renderIf(!!value)) {
                _this._container.createEmbeddedView(_this._ref);
            }
        });
    };
    UiContextDirectiveBase.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    return UiContextDirectiveBase;
}());
export { UiContextDirectiveBase };
var UiModernContextDirective = /** @class */ (function (_super) {
    tslib_1.__extends(UiModernContextDirective, _super);
    function UiModernContextDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._renderIf = function (value) { return value; };
        return _this;
    }
    return UiModernContextDirective;
}(UiContextDirectiveBase));
export { UiModernContextDirective };
var UiLegacyContextDirective = /** @class */ (function (_super) {
    tslib_1.__extends(UiLegacyContextDirective, _super);
    function UiLegacyContextDirective() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._renderIf = function (value) { return !value; };
        return _this;
    }
    return UiLegacyContextDirective;
}(UiContextDirectiveBase));
export { UiLegacyContextDirective };
